export default (dataKey = null, dataDefault = '') => {
    if (!dataKey) {
        return dataDefault;
    }

    const dataObject = document.querySelector('#page-header');
    let data = dataDefault;

    if (dataObject.hasAttribute(dataKey)) {
        data = dataObject.getAttribute(dataKey);
    }

    return data;
};
